import { ReactElement, useMemo } from "react"
import { Alert, Stack } from "@mui/material"
import { Loading } from "components/controls/loading"
import { DashBoardValue } from "features/dashBoard/hooks"

type GraphRenderProps<T> = {
	invalid?: boolean
	dashBoard: DashBoardValue<T>
	keys?: (string | undefined)[]
	optionKeys?: (string | undefined)[]
	children: ReactElement
}
export const GraphRender = <T,>({
	invalid,
	dashBoard: {
    subSource: {
      mrp,
      lv
    }
  },
	keys,
	optionKeys,
	children
}: GraphRenderProps<T>) => {
  const state = useMemo(
    () => {
			let hasLv = false
			let hasMrp = false
			if (keys) {
				for(const key of keys) {
					if (!key) return 'disable'
					if (lv.keys.indexOf(key) >= 0) hasLv = true
					if (mrp.keys.indexOf(key) >= 0) hasMrp = true
				}
			}
			if (optionKeys) {
				for(const key of optionKeys) {
					if (!key) continue
					if (lv.keys.indexOf(key) >= 0) hasLv = true
					if (mrp.keys.indexOf(key) >= 0) hasMrp = true
				}
			}
			if (hasMrp) {
        if (!mrp.keyValue) return 'chooseMrpProject'
        if (mrp.dataState.loading) return 'loading'
        if ((mrp.dataState.data?.list.length ?? 0) === 0) return 'nodata'
			}
			if (hasLv) {
        if (!lv.keyValue) return 'chooseLvProject'
        if (lv.dataState.loading) return 'loading'
        if ((lv.dataState.data?.list.length ?? 0) === 0) return 'nodata'
			}
      if (invalid) return 'hidden'
      return 'enable'
    },
    [
      invalid, keys, optionKeys,
      mrp.keys, mrp.keyValue, mrp.dataState,
      lv.keys, lv.keyValue, lv.dataState
    ]
  )
	return state === 'loading' ? (
    <Loading/>
  ) : state === 'chooseLvProject' ? (
    <Stack justifyContent="center" alignItems="center" width="100%" height="100%">
      <Alert severity='info' sx={{ wordBreak: 'break-all' }}>
        Web講演会プロジェクトを選択して下さい
      </Alert>
    </Stack>
  ) : state === 'chooseMrpProject' ? (
    <Stack justifyContent="center" alignItems="center" width="100%" height="100%">
      <Alert severity='info' sx={{ wordBreak: 'break-all' }}>
        MRPプロジェクトを選択して下さい
      </Alert>
    </Stack>
  ) : state === 'nodata' ? (
    <Stack justifyContent="center" alignItems="center" width="100%" height="100%">
      <Alert severity='info' sx={{ wordBreak: 'break-all' }}>
        データが存在しません
      </Alert>
    </Stack>
  ) : state === 'enable' ? (
		children
	) : <></>
}